import { render, staticRenderFns } from "./BidReport.vue?vue&type=template&id=54e03696&scoped=true"
import script from "./BidReport.vue?vue&type=script&lang=js"
export * from "./BidReport.vue?vue&type=script&lang=js"
import style0 from "./BidReport.vue?vue&type=style&index=0&id=54e03696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e03696",
  null
  
)

export default component.exports